interface PanelShowAllToggleProps {
  expanded: boolean;
  totalRows: number;
  defaultLimit: number;
  onToggle: () => void;
}

/**
 * Inline "Show all (N)" / "Show top N" toggle. State is owned by the
 * containing panel (no URL persistence per PRODOPSAI-333 spec).
 */
export function PanelShowAllToggle({
  expanded,
  totalRows,
  defaultLimit,
  onToggle,
}: Readonly<PanelShowAllToggleProps>) {
  const label = expanded ? `Show top ${defaultLimit}` : `Show all (${totalRows})`;
  return (
    <div className="mt-3 flex justify-end">
      <button
        type="button"
        onClick={onToggle}
        className="text-xs font-medium text-primary hover:underline focus:outline-none"
      >
        {label}
      </button>
    </div>
  );
}
